module.exports = __webpack_public_path__ + "static/img/edit_icon.4a57835.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/edit_icon.png
// module id = CR4j
// module chunks = 1